<div class="heading-flex">
  <div class="vertical-center header-content">
    <a class="header-link" matTooltip="{{ variables?.goBack }}" matTooltipPosition="below"
      aria-label="{{ variables?.goBack }}" (click)="goBack()">
      <mat-icon class="header-icon-img">arrow_circle_left</mat-icon>
    </a>
      <h4 class="notification-config-title">{{ variables?.configureNotifications || 'Configurar notificaciones' }}</h4>
  </div>
</div>

@if (isLoading && !errorDetected) {
  <div class="loader-wrapper">
    <app-loader></app-loader>
  </div>
}

@if (errorDetected) {
<app-error-message [errorMsg]="errorText"></app-error-message>
}

@if (!isLoading && !errorDetected) {

  <div class="table-card">
    <table mat-table [dataSource]="configs" class="config-table">

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>{{ variables?.notificationType || 'Type' }}</th>
        <td mat-cell *matCellDef="let row">
          {{ getTypeMeta(row.eventType)?.icon }}
          {{ getTranslatedTypeLabel(getTypeMeta(row.eventType)?.code || '', getTypeMeta(row.eventType)?.label || row.eventType) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="notice">
        <th mat-header-cell *matHeaderCellDef>{{ variables?.channelNotice || 'Canal aviso' }}</th>
        <td mat-cell *matCellDef="let row" class="channel-cell">
          @if (isChannelDisabled(row, noticeChannel)) {
            <mat-icon class="disabled-channel-icon" aria-hidden="true">close</mat-icon>
          }
          @else {
          <mat-checkbox
            [checked]="isChannelConfigurable(row, noticeChannel)"
            (change)="onConfigurableChannelToggle(row, noticeChannel, $event.checked)">
          </mat-checkbox>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ variables?.channelEmail || 'Canal correo' }}</th>
        <td mat-cell *matCellDef="let row" class="channel-cell">
          @if (isChannelDisabled(row, emailChannel)) {
            <mat-icon class="disabled-channel-icon" aria-hidden="true">close</mat-icon>
          }
          @else {
          <mat-checkbox
            [checked]="isChannelConfigurable(row, emailChannel)"
            (change)="onConfigurableChannelToggle(row, emailChannel, $event.checked)">
          </mat-checkbox>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['type', 'notice', 'email']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['type', 'notice', 'email'];"></tr>
    </table>
  </div>
}

@if (!isLoading && !errorDetected) {
  <div class="save-actions">
    <app-button typeBtn="primary" (click)="saveConfig()" [message]="variables?.save || 'Guardar'"></app-button>
  </div>
}
